import { userKey } from 'constants/storage';
import { getItemStorage } from 'services/storage';
import { ILoginResponse } from 'types/auth';

export const getLoggedUser = () => {
  const data = getItemStorage(userKey);

  return (data as ILoginResponse) || false;
};
